import React, { useState, useEffect } from "react";
import { ROW_COUNT } from "../../helpers/variableHelper";
import { AdminListColumn, IForm } from "./HelpRender";
import { ColumnDef, flexRender, getCoreRowModel, getSortedRowModel, SortingState, ColumnFiltersState, useReactTable } from "@tanstack/react-table";
import { Form, Offcanvas } from "react-bootstrap";
import RenderForm from "./RenderForm";
import { PrimaryButton, Separator } from "@fluentui/react";
import asc from "../../assets/img/asc.png";
import desc from "../../assets/img/desc.png";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import Loading from "../../cross/Loading";
import InputColumn from "./InputColumn";
import CustomToast from "../../cross/CustomToast";

interface IPagination {
  paging?: any;
  pages: number;
  page: number;
  sort?: any;
}
interface IAdminLista {
  data: any[];
  tipo: string;
  callback: any;
  parentchild?: any;
  loadFromSelected?: any;
  selectedItem?: any;
  items?: any;
  reload: any;
  pagination?: IPagination;
  filter?: any;
  exportar?: any;
  hideAdd?: boolean;
  hideAddForm?: boolean;
  hideReload?: boolean;
  title?: string;
  columnsDef?: any[];
  hideExport?: boolean;
  callbackRenderForm?: (data: any) => void;
  callbackUpdatePageSize?: (pageSize: number, filters: Object) => void;
  hideTable?: boolean;
  isLoading?: boolean;
  hidePagination?: boolean;
  autoLoad?: boolean;
}

function RenderOptions(header: any, filterValue: any, filterHandler: any, onChangeFilter: any, id: string) {
  let val = "";
  if (filterValue != null && filterValue[header.id] != null) {
    val = filterValue[header.id] ? "1" : "0";
  }
  if (header.id != "editar" && !header.column.columnDef.disableSorting) {
    if (header.column.columnDef.tipo === ITipo_Campo.check) {
      return (
        <select
          value={val}
          className="w-100 paddingSelect rounded border border-1"
          onChange={(input: any) => filterHandler(header.id, input.currentTarget.value, header.column.columnDef.tipo)}>
          <option value="">...</option>
          <option value="1">Sí</option>
          <option value="0">No</option>
        </select>
      );
    } else if (header.column.columnDef.tipo === ITipo_Campo.date) {
      return (
        <Form.Control
          className="calendarioFiltro"
          onChange={(input: any) => {
            filterHandler(header.id, input.currentTarget.value, header.column.columnDef.tipo);
          }}
          type="date"
          name={id}
        />
      );
    } else {
      return (
        <div>
          <InputColumn
            type={header.column.columnDef.tipo === ITipo_Campo.date ? "date" : "text"}
            onchange={onChangeFilter}
            headerId={header.id}
            tipo={header.column.columnDef.tipo}
            className="w-100 rounded border border-1 "
          />
        </div>
      );
    }
  }
}

const AdminLista = ({
  data,
  hideExport,
  tipo,
  selectedItem,
  callback,
  loadFromSelected,
  isLoading,
  hideTable,
  parentchild,
  items,
  reload,
  pagination,
  filter,
  exportar,
  hideAdd,
  hideReload,
  hideAddForm,
  title,
  columnsDef,
  callbackRenderForm,
  callbackUpdatePageSize,
  hidePagination,
  autoLoad = true,
}: IAdminLista) => {
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const [columnFilters, setFiltering] = React.useState<ColumnFiltersState>([]);

  const [show, setShow] = useState(false);
  const [columns, setColumns] = useState(columnsDef || AdminListColumn(tipo));

  const [selected, setSelected] = useState(selectedItem !== undefined ? selectedItem : ({} as any));
  const [id] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [filterValue, setFilter] = useState({} as any);
  const [orderBy, setOrderBy] = useState("DESC");
  const [orderByColumn, setOrderByColumn] = useState("");
  const [isLoadingComponent, setIsLoadingComponent] = useState(false);
  const [selectedPageSize, setSelectedPageSize] = useState(ROW_COUNT);

  useEffect(() => {
    //ejecutar al abrir el popup
    if (callbackRenderForm && show) {
      callbackRenderForm(selected);
    }
    if (!show && autoLoad) {
      setIsLoadingComponent(true);
      reload(filterValue);
      setIsLoadingComponent(false);

      let nColumns = columns;
      nColumns.forEach((c) => (c.errorEmpty = false));
      nColumns.sort((a, b) => a.sorteditmode - b.sorteditmode);
      setColumns(nColumns);
    }
  }, [show]);

  useEffect(() => {
    if (columnsDef) {
      columnsDef.sort((a, b) => a.sorteditmode - b.sorteditmode);
      setColumns(columnsDef as any);
    }
  }, [columnsDef]);

  useEffect(() => {}, [filterValue]);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
      columnFilters,
    },
    manualSorting: true,
    onColumnFiltersChange: setFiltering,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  const change = (id: string, valor: any, tipo: ITipo_Campo, optValueId?: number) => {
    // NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 50 como valor de complejidad cognitiva. Esta función realiza varias validaciones al ser un componente reutilizable, que se necesita para devolver los valores de los campos de formulario.".
    let item = selected;
    if (item !== undefined) {
      if ((typeof valor === "string" || typeof valor === "boolean") && tipo !== ITipo_Campo.multicheck) {
        item[id] = valor;
      } else if (tipo === ITipo_Campo.multicheck) {
        let opts: Array<any> = item[id] || [];
        if (valor) {
          opts.push(optValueId);
        } else {
          opts = opts.filter((o) => o !== optValueId);
        }
        item[id] = opts;
      } else if (tipo === ITipo_Campo.multiuser) {
        let mail = (valor as Array<any>).map((m) => m.mail).join("; ");
        item[id] = mail || null;
        let name = (valor as Array<any>).map((m) => m.name).join("; ");
        item[`${id}_DISPLAY`] = name || null;
      } else if (tipo === ITipo_Campo.combo) {
        item[id] = valor;
      } else {
        let mail = valor[0]?.mail;
        item[id] = mail || null;
        let name = valor[0]?.name;
        name = name?.replace(` (${mail})`, "");
        item[`${id}_DISPLAY`] = name || null;
      }
      setSelected(item);
      if (parentchild) {
        parentchild(id, valor);
      }
    }
  };

  const pageHandler = (page: number) => {
    let handler = filterValue || {};
    handler["PAGINA"] = page;
    setFilter(handler);
    filter(handler, true);
  };
  const sortHandler = (column: string, direction: string) => {
    let handler = filterValue || {};
    handler["ORDENADOPOR"] = column;
    handler["ORIENTACION"] = direction;
    setFilter(handler);
    filter(handler);
  };
  const deleteSorting = () => {
    let handler = filterValue || {};
    handler["ORDENADOPOR"] = "ID";
    handler["ORIENTACION"] = "DESC";
    setOrderByColumn("");
    setOrderBy("DESC");
    setFilter(handler);
    filter(handler);
  };
  const filterHandler = (id: string, value: any, type: ITipo_Campo) => {
    let handler = filterValue || {};
    handler.PAGINA = 1;
    if (type === ITipo_Campo.check) {
      if (value === "...") {
        delete handler[id];
      } else {
        if (value === "") {
          value = null;
        } else {
          value = value === "1" ? true : false;
        }
        handler[id] = value;
      }
    } else {
      handler[id] = value;
    }
    setFilter(handler);
    if (pagination) {
      filter(handler);
    }
  };

  const formValidation = (): boolean => {
    let flag = true;
    let nColumns = columns;

    nColumns.forEach((c) => {
      if (c.required && (c.tipo === ITipo_Campo.user ? !selected[c.id] || !selected[c.id + "_DISPLAY"] : !selected[c.id])) {
        flag = false;
        c.errorEmpty = true;
      } else {
        c.errorEmpty = false;
      }
    });
    nColumns.sort((a, b) => a.sorteditmode - b.sorteditmode);
    setColumns([...nColumns]);
    return flag;
  };

  const onChangeFilter = (headerId: string, value: string, tipo: ITipo_Campo) => {
    filterHandler(headerId, value, tipo);
  };

  const initializeFilter = () => {
    let handler = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
    };
    setFilter(handler);
  };

  return (
    <section className={`${hideTable ? "hidden" : ""}`}>
      <button
        hidden={true}
        data-testid="testsort"
        onClick={() => {
          sortHandler("", "");
        }}></button>
      <button
        hidden={true}
        data-testid="testchange"
        onClick={() => {
          change("", false, ITipo_Campo.multicheck, 1);
        }}></button>
      <button
        hidden={true}
        data-testid="testchange2"
        onClick={() => {
          change("", [{ mail: "", name: "" }], ITipo_Campo.multiuser, 1);
        }}></button>
      <button
        hidden={true}
        data-testid="testchange3"
        onClick={() => {
          change("", {}, ITipo_Campo.combo, 1);
        }}></button>
      <button
        hidden={true}
        data-testid="testchange4"
        onClick={() => {
          change("", [{ mail: "", name: "" }], ITipo_Campo.user, 1);
        }}></button>
      <button
        hidden={true}
        data-testid="testdeletesort"
        onClick={() => {
          deleteSorting();
        }}></button>
      <button
        hidden={true}
        data-testid="testfilter"
        onClick={() => {
          filterHandler("", "", ITipo_Campo.text);
        }}></button>
      <button
        hidden={true}
        data-testid="testfilterchek"
        onClick={() => {
          filterHandler("", "", ITipo_Campo.check);
        }}></button>
      <button
        hidden={true}
        data-testid="testformValidation "
        onClick={() => {
          formValidation();
        }}></button>
      <button
        hidden={true}
        data-testid="testonChangeFilter "
        onClick={() => {
          onChangeFilter("", "", 1);
        }}></button>
      <div className="row">
        <div className="col-12 p-2">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-4">
              <h1 className="titPrincipal colorTit mt-2">{title}</h1>
              <div className="row mb-1">
                <div className="col-6">
                  {hideAdd || (
                    <button
                      data-testid="testbtnagregar"
                      className="btn btn-primary btn-sm"
                      onClick={() => {
                        setShow(true);
                        setSelected({});
                        loadFromSelected({});
                      }}>
                      {" "}
                      <i className="bi bi-plus-circle-fill"></i> Agregar
                    </button>
                  )}
                </div>
                <div className="col-3"></div>

                <div className="col-3 text-end">
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    data-testid="testbtnrecargar"
                    hidden={hideReload}
                    onClick={async () => {
                      initializeFilter();
                      setOrderByColumn("");
                      setOrderBy("");
                      setIsLoadingComponent(true);
                      await reload();
                      setIsLoadingComponent(false);
                    }}>
                    {" "}
                    <i className="bi bi-arrow-clockwise"></i> Recargar
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-12 p-0">
                  <div className="table-responsive">
                    {isLoading && <Loading key="loadingAdminLista" cssContainer="loadingFlotante" />}
                    {isLoadingComponent ? (
                      <Loading></Loading>
                    ) : (
                      <table className="table table-hover tablaTLC table-sm">
                        <thead>
                          {table.getHeaderGroups().map(
                            (
                              headerGroup // NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 50 como valor de complejidad cognitiva. Esta función realiza varias validaciones al ser un componente reutilizable, que se necesita para armar la cabecera de las grillas de los módulos".
                            ) => (
                              <tr key={headerGroup.id}>
                                {headerGroup.headers.map((header: any) => {
                                  if (!header.column.columnDef.hide) {
                                    return (
                                      <React.Fragment key={header.id}>
                                        <th key={header.id} colSpan={header.colSpan}>
                                          {header.isPlaceholder ? null : (
                                            <div
                                              className={header.id === "editar" ? "" : "order"}
                                              onClick={(e: any) => {
                                                if (e.target.className.indexOf("delete") > 0 || e.target.className.indexOf("trash") > 0) {
                                                  deleteSorting();
                                                } else {
                                                  if (header.id === "editar") return;
                                                  sortHandler(header.column.columnDef.sortId || header.id, orderBy === "ASC" ? "DESC" : "ASC");
                                                  setOrderByColumn(header.column.columnDef.sortId || header.id);
                                                  setOrderBy(orderBy === "ASC" ? "DESC" : "ASC");
                                                }
                                              }}>
                                              {flexRender(header.column.columnDef.header, header.getContext())}
                                              {orderByColumn === header.id || orderByColumn === header.column.columnDef.sortId ? (
                                                <span className="ms-1">
                                                  <img height={16} width={16} src={orderBy === "ASC" ? asc : desc} className="bg-transparent" />
                                                  <span className="delete-filter">
                                                    <i className="bi bi-trash text-secondary"></i>
                                                  </span>
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          )}
                                        </th>
                                      </React.Fragment>
                                    );
                                  }
                                })}
                              </tr>
                            )
                          )}
                        </thead>
                        <tbody>
                          <tr>
                            {table.getHeaderGroups().map((headerGroup) =>
                              headerGroup.headers.map((header) => {
                                if (!(header.column.columnDef as any).hide) {
                                  return <td key={header.id}>{RenderOptions(header, filterValue, filterHandler, onChangeFilter, id)}</td>;
                                }
                              })
                            )}
                          </tr>
                        </tbody>

                        {data.length === 0 ? (
                          <span>No se encontraron registros</span>
                        ) : (
                          <tbody>
                            {table.getRowModel().rows.map((row) => {
                              return (
                                <tr key={row.id}>
                                  {row.getVisibleCells().map((cell) => {
                                    if (!(cell.column.columnDef as any).hide) {
                                      return (
                                        <td
                                          key={cell.id}
                                          data-id={cell.column.columnDef.id}
                                          className={(cell.column.columnDef as any).className}
                                          onClick={() => {
                                            if ((cell.column.columnDef as any).onSelectColumn) (cell.column.columnDef as any).onSelectColumn(cell);
                                          }}>
                                          {cell.id === `${row.id}_editar` ? (
                                            <a
                                              className="text-decoration-none"
                                              data-bs-toggle="offcanvas"
                                              data-bs-target="#offcanvasRight"
                                              aria-controls="offcanvasRight">
                                              <i
                                                className="bi bi-search"
                                                onClick={() => {
                                                  setShow(true);
                                                  const nRow = row["original"];
                                                  setSelected(nRow);
                                                  loadFromSelected(nRow);
                                                }}></i>
                                            </a>
                                          ) : (
                                            flexRender(cell.column.columnDef.cell, cell.getContext())
                                          )}
                                        </td>
                                      );
                                    }
                                  })}
                                </tr>
                              );
                            })}
                          </tbody>
                        )}
                      </table>
                    )}
                  </div>
                  {hidePagination || (
                    <div className="row justify-content-between">
                      <div className="col-6 d-flex">
                        <span className="me-2 mt-3">
                          <small>Mostrar Filas: </small>
                        </span>
                        <select
                          onChange={(e: any) => {
                            setSelectedPageSize(parseInt(e.target.value));
                            if (callbackUpdatePageSize) {
                              callbackUpdatePageSize(parseInt(e.target.value), filterValue);
                            }
                          }}
                          className="form-select form-select-sm selectPaginacion me-5 mt-3">
                          <option selected={selectedPageSize === 5} value="5">
                            5
                          </option>
                          <option selected={selectedPageSize === 10} value="10">
                            10
                          </option>
                          <option selected={selectedPageSize === 20} value="20">
                            20
                          </option>
                          <option selected={selectedPageSize === 50} value="50">
                            50
                          </option>
                        </select>
                      </div>
                      <div className="col-6 d-flex justify-content-end">
                        <div className="d-flex mt-3 me-4">
                          <span className="me-2">
                            <small>Ir a pág:</small>
                          </span>
                          <span className="me-2">
                            <Form.Control
                              type={"number"}
                              className={"form-control-sm"}
                              onChange={(e) => {
                                pageHandler(parseInt(e.target.value));
                              }}
                              name={id}
                              defaultValue={0}
                              value={data.length > 0 ? pagination?.page : 0}
                              min={0}
                              max={pagination?.pages}
                            />
                          </span>
                          <span>
                            <small>de {pagination?.pages}</small>
                          </span>
                        </div>
                        <nav aria-label="Page navigation example " hidden={isLoading}>
                          <ul className="pagination justify-content-end mt-3 pagination-sm">
                            <li
                              data-testid="testpagehandler"
                              className={`page-item ${pagination?.page === 1 ? "disabled" : ""}`}
                              onClick={() => {
                                let val: any;

                                if (pagination != undefined) {
                                  if (pagination?.page > 1) {
                                    pageHandler(pagination?.page - 1);
                                    val = true;
                                  }
                                }
                                return val;
                              }}
                              hidden={pagination?.pages === 1}>
                              <a className="page-link" tabIndex={-1} aria-disabled="true">
                                Anterior
                              </a>
                            </li>
                            <li
                              data-testid="testpagingsiguiente"
                              className={`page-item ${pagination?.page === pagination?.pages ? "disabled" : ""}`}
                              onClick={() => {
                                let val: any;

                                if (pagination != undefined) {
                                  if (pagination?.page < pagination?.pages) {
                                    pageHandler(pagination?.page + 1);
                                    val = true;
                                  }
                                }
                                return val;
                              }}
                              hidden={pagination?.pages === 1}>
                              <a className="page-link">Siguiente</a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  )}

                  <Offcanvas show={show} onHide={() => setShow(false)} placement={"end"}>
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>{title}</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <form
                        onKeyDown={(e) => {
                          let key = e.key || 0;
                          if (key === "Enter") e.preventDefault();
                        }}>
                        {columns.map((col: IForm & ColumnDef<any, number>) => {
                          // NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 50 como valor de complejidad cognitiva. Esta función realiza varias validaciones al ser un componente reutilizable, que se necesita para armar la cabecera de las grillas de los módulos".

                          let itemCombo = {};
                          let valor = selected[col.id];

                          if (col.tipo === ITipo_Campo.combo) {
                            if (items != undefined) {
                              itemCombo = items.find((i: any) => i.type === col.id);
                            }
                          }

                          if (col.tipo === ITipo_Campo.text) {
                            if (items != undefined) {
                              let its = items.find((i: any) => i.type === col.id);
                              if (its != undefined) {
                                valor = its.value;
                              }
                            }
                          }

                          if (col.tipo === ITipo_Campo.user) {
                            let name = selected[`${col.id}_DISPLAY`];
                            let mail = selected[col.id];

                            let nameDisplay = name && mail ? `${name} (${mail})` : name;
                            valor = { name: nameDisplay, mail: mail };
                          } else if (col.tipo === ITipo_Campo.multiuser) {
                            if (selected[col.id]) {
                              let arr: Array<any> = [];
                              selected[col.id].split(";").forEach((element: string, i: number) => {
                                let name = selected[`${col.id}_DISPLAY`].split(";")[i];
                                let mail = element;
                                let nameDisplay = name && mail ? `${name} (${mail})` : name; //nested ternari necesaria para validar el nombre del usuario
                                arr.push({ name: nameDisplay, mail: mail });
                              });
                              valor = arr;
                            }
                          }

                          if (col.tipo === ITipo_Campo.check) {
                            if (selected.ID <= 0 && col.id.toLocaleUpperCase() === "ACTIVO") {
                              valor = "1";
                              selected[col.id] = true;
                            }
                          }

                          return col.id != undefined && col.tipo != ITipo_Campo.none ? (
                            <React.Fragment>
                              <span className="ajusteInput" hidden={col.hideColOnEdit}>
                                <RenderForm
                                  id={col.id}
                                  tipoCampo={col.tipo}
                                  readonly={col.readonly}
                                  required={col.required}
                                  items={itemCombo}
                                  callback={change}
                                  valor={valor}
                                  texto={col.title}
                                  callbackColumn={col.callback}
                                  errorEmpty={col.errorEmpty}
                                  options={col.options}
                                />
                                {col.hideColOnEdit ? <Separator className="p-0 font10" /> : ""}
                              </span>
                            </React.Fragment>
                          ) : (
                            <p></p>
                          );
                        })}

                        <PrimaryButton
                          hidden={!hideAddForm}
                          text={selected.ID > 0 ? "Editar" : "Agregar"}
                          className="me-1"
                          data-testid="btneditar"
                          onClick={() => {
                            let json = {} as any;
                            if (formValidation()) {
                              json = selected;
                              callback(json, filterValue);
                              setShowToast(true);
                            }
                          }}
                        />

                        <PrimaryButton
                          hidden={!hideAddForm}
                          text={"Cerrar"}
                          className="me-1"
                          onClick={() => {
                            setShow(false);
                          }}
                        />
                        <PrimaryButton
                          hidden={hideAddForm}
                          data-testid="btneditar"
                          text={selected.ID > 0 ? "Editar" : "Agregar"}
                          className="me-1"
                          onClick={() => {
                            if (formValidation()) {
                              let json = selected;
                              filterValue.PAGINA = pagination != undefined && (selected.ID === undefined || selected.ID <= 0) ? 1 : pagination?.page;
                              callback(json, filterValue);
                              setShowToast(true);
                              setShow(false);
                            }
                          }}
                        />
                      </form>
                    </Offcanvas.Body>
                  </Offcanvas>
                </div>
              </div>
              <div className="row">
                <div className="col-6"></div>
                {
                  <div className="col-6 text-end">
                    <button
                      hidden={hideExport}
                      className="btn btn-success btn-sm"
                      onClick={() => {
                        exportar();
                      }}>
                      {" "}
                      <i className="bi bi-file-earmark-excel"></i> Exportar
                    </button>
                  </div>
                }
              </div>
              <div className="row">
                <div className="col-12">
                  <CustomToast show={showToast} title="Administración" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminLista;
